import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSoftUIController, setMiniSidenav } from "context";
import { useAuth } from "context/AuthContext";
import { useFinance } from "context/FinanceContext";
import {
  FiGrid,
  FiUsers,
  FiRepeat,
  FiDollarSign,
  FiBook,
  FiSettings,
  FiLogOut,
  FiCheckSquare,
  FiBarChart2,
  FiLayers,
  FiActivity,
  FiShield,
  FiUserCheck,
  FiCreditCard,
  FiShare2,
  FiX,
} from "react-icons/fi";
const icons = {
  dashboard: FiGrid,
  merchants: FiUsers,
  transactions: FiRepeat,
  "merchant-charges": FiDollarSign,
  ledger: FiBook,
  settings: FiSettings,
  "logout-user": FiLogOut,
  "finance-overview": FiBarChart2,
  settlements: FiLayers,
  "payout-approvals": FiCheckSquare,
  reconciliation: FiShield,
  "switch-performance": FiActivity,
  "finance-reports": FiBarChart2,
  "pricing-rules": FiDollarSign,
  "chart-of-accounts": FiBook,
  "user-management": FiUserCheck,
  wallets: FiCreditCard,
  referrals: FiShare2,
};
export default function Sidenav({ routes }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const { user, role, hasAccess } = useAuth();
  const { queue, error } = useFinance();
  const { pathname } = useLocation();
  useEffect(() => {
    const resize = () => setMiniSidenav(dispatch, window.innerWidth < 1200);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [dispatch]);
  useEffect(() => {
    if (window.innerWidth < 1200) setMiniSidenav(dispatch, true);
  }, [pathname, dispatch]);
  const groups = [
    [
      "Workspace",
      ["dashboard", "merchants", "transactions", "merchant-charges", "ledger"],
    ],
    [
      "Financial operations",
      [
        "finance-overview",
        "settlements",
        "payout-approvals",
        "reconciliation",
        "switch-performance",
        "finance-reports",
      ],
    ],
    [
      "Administration",
      [
        "user-management",
        "wallets",
        "referrals",
        "pricing-rules",
        "chart-of-accounts",
        "settings",
        "logout-user",
      ],
    ],
  ];
  return (
    <>
      {!miniSidenav && (
        <button
          className="sidebar-backdrop"
          aria-label="Close navigation"
          onClick={() => setMiniSidenav(dispatch, true)}
        />
      )}
      <aside className={`admin-sidebar ${miniSidenav ? "collapsed" : ""}`}>
        <NavLink to="/dashboard" className="sidebar-brand">
          <span className="brand-mark">F</span>
          <span>
            <strong>Fairsure</strong>
            <small>Payment Limited · Admin</small>
          </span>
        </NavLink>
        <button
          className="sidebar-close"
          aria-label="Close navigation"
          onClick={() => setMiniSidenav(dispatch, true)}
        >
          <FiX />
        </button>
        <nav aria-label="Main navigation">
          {groups.map(([label, keys]) => (
            <div className="sidebar-group" key={label}>
              <p>{label}</p>
              {keys.map((key) => {
                const route = routes.find((r) => r.key === key);
                if (
                  !route ||
                  route.showInSidenav === false ||
                  !hasAccess(route.resource)
                )
                  return null;
                const Icon = icons[key] || FiGrid;
                return (
                  <NavLink
                    key={key}
                    to={route.route}
                    title={route.name}
                    className={({ isActive }) =>
                      `admin-nav-link ${isActive ? "active" : ""}`
                    }
                  >
                    <Icon aria-hidden="true" />
                    <span>{route.name}</span>
                    {key === "payout-approvals" && !error && (
                      <b className="nav-count">{queue.length}</b>
                    )}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>
        <div className="sidebar-account">
          <span className="user-avatar">
            {(user?.firstName || "A").slice(0, 1)}
          </span>
          <div>
            <strong>
              {user?.firstName || "Admin"} {user?.lastName || ""}
            </strong>
            <small>{role}</small>
          </div>
        </div>
      </aside>
    </>
  );
}
